module.exports = __webpack_public_path__ + "large1.jpg?4301edd3a58b59f86048267a88110df0";